import { useWidget } from '../../../providers/widget'
import { BookingWidgetConfig } from '../config'
import Stylesheet from '../../../components/Stylesheet'
import WebFont from '../../../components/WebFont'
import BookingForm from './BookingForm'
import { useBookingCss } from '../hooks/useBookingCss'
import { resolveWidgetSpacingStyle } from "@homerunner-next/widget-core/spacing"

export default function BookingWidgetContent() {
  const { options, resolvedTheme } = useWidget<BookingWidgetConfig>()
  const cssString = useBookingCss()

  return (
    <div
      className={`homerunner-booking-container homerunner-booking-app w-full ${resolvedTheme === 'dark' ? 'dark' : ''}`}
      style={resolveWidgetSpacingStyle(options)}
      // #919: server-stable marker for the pre-hydration mobile rule in
      // booking.css. useIsMobile seeds false so the SSR HTML always carries
      // the inline card; without this a phone paints the whole desktop card
      // and then deletes it when the effect flips to the floating bar.
      data-hr-sticky={options.sticky?.enabled ? 'on' : undefined}
      suppressHydrationWarning
    >
      <WebFont />
      <Stylesheet css={cssString} />
      <BookingForm />
    </div>
  )
}
